export default "__VITE_ASSET__CxoVqF3F__"